export const brand = {
    white: '#FFFFFF',
    black: '#081020',
    error: '#FA3952',
    warn: '#FBBF10',
    'primary-blue': '#159DFF',
    'secondary-dark-blue': '#152C4B',
    'secondary-sky-blue': '#12CFF4',
    'secondary-purple': '#C140EA',
    'secondary-green': '#34F792',
    'gray-scale-white': '#FFFFFF',
    'gray-scale-5': 'rgba(255, 255, 255, 0.05)',
    'gray-scale-border-10': 'rgba(255, 255, 255, 0.1)',
    'gray-scale-border-20': 'rgba(255, 255, 255, 0.2)',
    'gray-scale-light-grey': '#D9D9D9',
    'gray-scale-gray-disabled': '#999999',
    'background-black': '#081020',
    'background-dark-blue': '#152C4B',
    'background-transparent-blue': 'rgba(21, 157, 255, 0.1)',
};
export const gradients = {
    'dark-blue': 'linear-gradient(0deg, #152C4B 0%, #081020 100%)',
    purple: 'linear-gradient(180deg, #C140EA 0%, #002D74 100%)',
    'sky-blue': 'linear-gradient(180deg, #12CFF4 0%, #002D74 100%)',
    green: 'linear-gradient(180deg, rgba(18, 207, 244, 0.20) 0%, rgba(0, 45, 116, 0.20) 100%)',
    'blue-horizontal': 'linear-gradient(270deg, #159DFF -0.75%, #081020 100%)',
    'purple-blue-Horizontal': 'linear-gradient(270deg, #12CFF4 -5.62%, #9534F7 47.19%, #152C4B 100%)',
    'blue-border-vertical': 'linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, #56E1FE 49.32%, rgba(255, 255, 255, 0.00) 97.77%)',
    'blue-border-horizontal': 'linear-gradient(0deg, rgba(255, 255, 255, 0.00) 0%, #56E1FE 49.32%, rgba(255, 255, 255, 0.00) 97.77%)',
    'white-blue-title': 'linear-gradient(93deg, #FFF 31.34%, #74EAFF 129.15%)',
    'white-blue-green-horizontal': 'linear-gradient(270deg, #34F792 48.2%, #12CFF4 74.1%, #FFF 100%)',
    'blue-green-horizontal': 'linear-gradient(270deg, #34F792 -0.75%, #12CFF4 100%)',
    'sky-blue-20': 'linear-gradient(180deg, rgba(18, 207, 244, 0.20) 0%, rgba(0, 45, 116, 0.20) 100%)',
    black: 'linear-gradient(0deg, #000 0%, #000 100%)',
    'dark-vertical': 'linear-gradient(0deg, #081020 0%, #152C4B 100%) padding-box',
    'aqua-radial': 'radial-gradient(81.01% 695.69% at -3.3% 126.14%, rgba(18, 244, 217, 0.6) 0%, rgba(0, 45, 116, 0) 100%)',
    'aqua-radial-2': 'radial-gradient(100% 300% at 0% 110%, rgba(18, 244, 217, 0.4) 0%, rgba(0, 45, 116, 0) 100%)',
    'green-purple-horizontal': 'linear-gradient(90deg, #34F792 0%, #B14DFF 100%)',
    'transparent-black-vertical': 'linear-gradient(to bottom, transparent, #081020)',
};
/**
 * when color stop position is either `> 100%` or `< 0%`,
 * we need to utilize coordinate system of SVG gradient to achieve the same effect as figma's
 */
const gradientsInSvg = {
    modalBg: `url('data:image/svg+xml,<svg width="438" height="516" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="438" height="516" fill="url(%23paint1_linear_675_2540)"/><defs><linearGradient id="paint1_linear_675_2540" x1="219" y1="-5.55266e-05" x2="-241.78" y2="203.104" gradientUnits="userSpaceOnUse"><stop stop-color="%23002D74" stop-opacity="0"/><stop offset="1" stop-color="%2345FFF2"/></linearGradient></defs></svg>')`,
};
export const oklchGradients = {
    'blue-green-horizontal': 'linear-gradient(270deg in oklch, #34F792 -0.75%, #12CFF4 100%)',
    'white-blue-green-horizontal': 'linear-gradient(270deg in oklch, #34F792 48.2%, #12CFF4 74.1%, #FFF 100%)',
    'white-blue-title': 'linear-gradient(93deg in oklch, #FFF 31.34%, #74EAFF 129.15%)',
    'green-purple-horizontal': 'linear-gradient(90deg in oklab, #34F792 0%, #B14DFF 100%)',
};
export const colors = {
    brand,
    gradients,
    gradientsInSvg,
};
